import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import * as subscriptionCancellationDuck from '../../../components/ui/SubscriptionCancellation/subscriptionCancellationDuck'
import PageTitle from '../../../components/ui/typography/PageTitle'
import BlankCard from '../../../components/ui/cards/BlankCard'
import {
  currentUserSuccess,
  currentUserPropTypes,
} from '../../../store/shared/currentUserDuck'
import withErrorBoundary from '../../../components/hocs/withErrorBoundary'
import * as interestSelectorDuck from '../../../components/ui/InterestSelector/interestSelectorDuck'
import accountUtils from '../../../utils/account/accountUtils'
import intercom from '../../../utils/intercom/intercomUtils'
import {
  performRetrieveUserProfile,
  userProfilePropTypes,
  performCancelSubscription,
} from './userProfileDuck'
import UserProfileBasicInfoSection from './components/UserProfileBasicInfoSection'
import * as contactUsDuck from './contactUsDuck'
import ContactUsModal from './components/ContactUsModal'
import selectors from "../../../store/shared/selectors"

export class AuthenticatedUserProfileIndex extends Component {
  constructor(props) {
    super(props)

    this.openSubscriptionCancellationModal = () => {
      this.props.openSubscriptionCancellationModal()
    }
  }

  componentWillMount() {
    this.props.performRetrieveUserProfile().then(this.props.currentUserSuccess)
  }

  componentDidMount() {
    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
  }

  render() {
    const { currentUser, isAbleToCancelSubscription, openInterestSelector, openContactUsModal } = this.props

    return (
      <div className="main-page">
        <PageTitle content="My Profile"/>
        <UserProfileBasicInfoSection
          currentUser={currentUser}
          onClickInterests={() => openInterestSelector()}
        />
        <BlankCard notCard delay={1.5}>
          <div className="row max-800" style={{marginTop: 50}}>
            <div className="col-sm-6">
              <div style={{marginBottom: 15}}><a href="https://www.steppingblocks.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></div>
              {/*<div style={{marginBottom: 15}}><a target="_blank" rel="noopener noreferrer">Terms & Conditions</a></div>*/}
              <div style={{marginBottom: 15}}>
                <Link to="/app/about">About</Link>
              </div>
            </div>
            <div className="col-sm-6 text-right">
              {/*<div style={{marginBottom: 15}}><a >*/}
                {/*FAQ*/}
              {/*</a></div>*/}
              <div style={{marginBottom: 15}}>
                <button className="btn btn-link" onClick={() => openContactUsModal()}>
                  Contact Us
                </button>
              </div>
              {isAbleToCancelSubscription &&
                <div style={{marginBottom: 15}}>
                  <a
                    href=""
                    onClick={e => {
                      e.preventDefault()
                      this.openSubscriptionCancellationModal()
                    }}
                  >
                    Cancel Subscription
                  </a>
                </div>
              }
            </div>
          </div>
        </BlankCard>
        <ContactUsModal/>
      </div>
    )
  }
}

AuthenticatedUserProfileIndex.propTypes = {
  currentUser: currentUserPropTypes,
  currentUserSuccess: PropTypes.func.isRequired,
  isAbleToCancelSubscription: PropTypes.bool,
  performRetrieveUserProfile: PropTypes.func.isRequired,
  performCancelSubscription: PropTypes.func.isRequired,
  userProfile: userProfilePropTypes,
  openInterestSelector: PropTypes.func.isRequired,
  openSubscriptionCancellationModal: PropTypes.func.isRequired,
  openContactUsModal: PropTypes.func,
  userId: PropTypes.string,
}

/**
 * @const mapStateToProps
 * @description Grabs data from redux and puts it onto this.props
 * @param _state
 */
const mapStateToProps = _state => ({
  currentUser: _state.currentUser,
  isAbleToCancelSubscription: accountUtils.isAbleToAddPayment(_state.currentUser.user),
  userId: selectors.getUserId(_state),
  userProfile: _state.userProfile,
})

/**
 * @const mapDispatchToProps
 * @description Takes our action-performers from the duck and puts them on this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess,
      performRetrieveUserProfile,
      performCancelSubscription,
      openSubscriptionCancellationModal: subscriptionCancellationDuck.openModal,
      openInterestSelector: interestSelectorDuck.openModal,
      openContactUsModal: contactUsDuck.openModal,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(
  withErrorBoundary(AuthenticatedUserProfileIndex),
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/AuthenticatedUserProfileIndex.js